var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProgressingSetting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1299",
    d: "M0-682.665H28v28H0Z",
    transform: "translate(0 682.665)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_42588",
    "data-name": "Group 42588",
    transform: "translate(17886 -6041)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15955",
    "data-name": "Rectangle 15955",
    width: 32,
    height: 32,
    transform: "translate(-17886 6041)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g1293",
    transform: "translate(-17884 6043)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1295"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1297",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1303",
    transform: "translate(0.828 0.837)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1305",
    d: "M-615.934-374.236v-5.116h-3.217a10.186,10.186,0,0,0-1.06-2.665l2.463-2.463-3.618-3.617-2.411,2.412a10.191,10.191,0,0,0-2.684-1.15v-3.406h-5.116v3.358a10.187,10.187,0,0,0-2.773,1.139l-2.21-2.21-3.618,3.617,2.221,2.221a10.183,10.183,0,0,0-1.119,2.765h-3.2v5.116H-639a10.19,10.19,0,0,0,1.138,2.639l-2.347,2.347,3.617,3.617,2.4-2.4a10.187,10.187,0,0,0,2.516,1.023v3.092h5.116V-367a10.188,10.188,0,0,0,2.636-1.087l2.475,2.475,3.618-3.617L-620.3-371.7a10.193,10.193,0,0,0,1.078-2.539Z",
    transform: "translate(642.277 390.242)",
    fill: "none",
    stroke: "#1564e8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1307",
    transform: "translate(7.697 8.321)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1309",
    d: "M0-68.511l.787,1.241a5.7,5.7,0,0,1,5.49-4.172,5.7,5.7,0,0,1,5.423,3.95",
    transform: "translate(0 71.441)",
    fill: "none",
    stroke: "#d1131d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1311",
    transform: "translate(8.485 12.125)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1313",
    d: "M-33.971,0l-1.453.367",
    transform: "translate(35.424)",
    fill: "none",
    stroke: "#d1131d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1315",
    transform: "translate(8.603 15.508)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1317",
    d: "M-273.56-29.026l-.787-1.241a5.7,5.7,0,0,1-5.49,4.172,5.7,5.7,0,0,1-5.423-3.95",
    transform: "translate(285.261 30.268)",
    fill: "none",
    stroke: "#d1131d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1319",
    transform: "translate(18.062 15.508)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1321",
    d: "M0-8.581l1.453-.367",
    transform: "translate(0 8.948)",
    fill: "none",
    stroke: "#d1131d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgressingSetting);
export default __webpack_public_path__ + "static/media/progressing-setting.628414328d00f8ac36968efe2f08722e.svg";
export { ForwardRef as ReactComponent };